import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { ServiceAppService } from '../service-app.service';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class GuardFabrica implements CanActivate {
    private urlRoute: string;
    caminho: any;

    constructor(private router: Router, private service: ServiceAppService) { }

    canActivate(route: ActivatedRouteSnapshot) {
        let rota = '';

        route.url.forEach(dados => {
            rota = rota + "/" + dados.path;
            this.urlRoute = rota.substring(1);
        });

        return this.service.verificarRotas(this.urlRoute).pipe(
            switchMap((res) => {
                this.caminho = res;
                if ("/" + this.caminho.rota == rota && this.caminho.visivel == true) {
                    return of(true);
                } else {
                    this.router.navigate(['']);
                    return of(false);
                }
            })
        );
    }
}